import { IGetState, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { highlightCardIdSet } from '../../../../store/actions/highlightCardIdSet';
import { CARD_BLINK_ANIMATION_TIME } from '../../../Card/components/Card/constants';

export const onClick = (
    cardId: TCardId,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const { epicId } = getCard(getState(), cardId);
        dispatch(highlightCardIdSet(epicId));
        setTimeout(() => {
            dispatch(highlightCardIdSet(null));
        }, CARD_BLINK_ANIMATION_TIME);
    };
};
